import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { getRescheduledData } from "../../../../redux/features/croSlice";
import { Ta_Reschedule_Table_Head } from "../../../../components/datagrid/rechedule/TaRescheduleTablehead";

const TAReschedule = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, rescheduledData } = useSelector((state) => state.cro);

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
  };

  useEffect(() => {
    dispatch(getRescheduledData(data));
  }, [pageNum, gridSize]);

  return (
    <GlobalWrapper title={"TA Rescheduled Lists"}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 2 }}>
        <Stack direction={"row"} spacing={2}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                value={value}
                views={["year", "month"]}
                onChange={(newValue) => setValue(newValue)}
                format="YYYY-MM" //
              />
            </LocalizationProvider>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Ta_Reschedule_Table_Head}
          rows={rescheduledData.data}
          meta={rescheduledData?.meta?.totalRecords || 0}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TAReschedule;
